// XBRL 분석에 쓸 LLM 모드. analyzeXbrl 호출 시점에 읽혀 liteMode로 백엔드에 전달된다.
// "none"이면 현재(기본) 모델, "mini"/"nano"는 더 저렴한 디버깅용 모델.
export type LlmMode = "none" | "mini" | "nano";

const LLM_MODE_LOCAL_STORAGE_KEY = "llm-mode";

let cachedLlmMode: LlmMode | null = null;

const isLlmMode = (value: string | null): value is LlmMode =>
  value === "none" || value === "mini" || value === "nano";

const readLlmMode = (): LlmMode => {
  if (typeof localStorage === "undefined") return "none";
  const stored = localStorage.getItem(LLM_MODE_LOCAL_STORAGE_KEY);
  return isLlmMode(stored) ? stored : "none";
};

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === LLM_MODE_LOCAL_STORAGE_KEY) {
      cachedLlmMode = null;
    }
  });
}

export const getLlmMode = (): LlmMode => {
  if (cachedLlmMode === null) {
    cachedLlmMode = readLlmMode();
  }
  return cachedLlmMode;
};

export const setLlmMode = (mode: LlmMode): void => {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(LLM_MODE_LOCAL_STORAGE_KEY, mode);
  cachedLlmMode = mode;
};
